module.exports = __webpack_public_path__ + "static/media/sun-mode.502e169d.svg";